import { axios } from "@/plugins/http-request.js";

const actions = {
  getChannelList(context, payload) {
    return axios
      .get(`/api/fulfillment/channel_sku_mapping_list`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  channelSkuMapping(context, payload) {
    return axios
      .post(`/api/fulfillment/channel_sku_mapping`, payload)
      .then((res) => res.data);
  },
  downloadChannels(context, payload) {
    return axios
      .post(`/api/fulfillment/unlinked_sku_download`, payload, {
        responseType: "blob",
      })
      .then((res) => res);
  },
  getChannelDropdown(context, id) {
    return axios
      .get(`/api/fulfillment/client_channel_list?client_id=${id}`)
      .then((res) => res.data);
  },

  getChannelDropdownReport(context, id) {
    return axios
      .get(`/api/fulfillment/client_channel_list?client_id=${id}&status=true`)
      .then((res) => res.data);
  },
  getChannelDropdownBB(context, id) {
    return axios
      .get(`/api/fulfillment/client_channel_list?client_id=${id}&variant=1`)
      .then((res) => res.data);
  },
  getWarehouseStores(context, payload) {
    return axios
      .get(`/api/fulfillment/client_channel_list`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  syncChannel(context, payload) {
    return axios
      .post(`/api/fulfillment/channel_sku_sync`, payload)
      .then((res) => res.data);
  },
};
export default {
  actions,
};
